import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IStateAdmin, TAdminModal, TModalUser, TSortOrder } from '../../../@types/admin'
import { logout } from '../user/userSlice'


const initialState: IStateAdmin = {
    selectedUsers: [],
    tokensVisible: false,
    filters: {
        searchString: '',
        accessConfig: {
            access_console: false,
            access_asr: false,
            access_tts: false,
            access_admin: false
        },
        sortOrder: 'none'
    },
    loading: false,
    modal: {
        type: 'none',
        user: {
            auth_username: '',
            auth_token: '',
            access_console: false,
            access_asr: false,
            access_tts: false,
            access_admin: false
        }
    }
}

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        updateSearchString(state, action: PayloadAction<string>) {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    searchString: action.payload
                }
            }
        },
        updateSelectedUsersList(state, action: PayloadAction<number>) {
            const id = action.payload

            return {
                ...state,
                selectedUsers: state.selectedUsers.includes(id)
                    ? state.selectedUsers.filter(userId => id !== userId)
                    : [
                        ...state.selectedUsers,
                        action.payload
                    ]
            }
        },
        updateAccessConfigFilter(state, action) {
            const access = action.payload

            return {
                ...state,
                filters: {
                    ...state.filters,
                    accessConfig: {
                        ...state.filters.accessConfig,
                        ...access
                    }

                }
            }
        },
        setModalVisibility(state, action: PayloadAction<TAdminModal>) {
            return {
                ...state,
                modal: {
                    ...state.modal,
                    type: action.payload
                }
            }
        },
        updateModalSettings(state, action: PayloadAction<Partial<TModalUser>>) {
            return {
                ...state,
                modal: {
                    ...state.modal,
                    user: {
                        ...state.modal.user,
                        ...action.payload
                    }
                }
            }
        },
        toggleTokensVisible(state) {
            state.tokensVisible = !state.tokensVisible
        },
        selectAllUsers(state, action: PayloadAction<number[]>) {
            const allIds = action.payload
            const allSelected = allIds.every(id => state.selectedUsers.includes(id))
            state.selectedUsers = allSelected ? [] : allIds
        },
        toggleSortOrder(state) {
            const next: Record<TSortOrder, TSortOrder> = { none: 'asc', asc: 'desc', desc: 'none' }
            state.filters.sortOrder = next[state.filters.sortOrder]
        },
        setDefaultModalSettings(state) {
            return {
                ...state,
                modal: initialState.modal
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => initialState)
    }
})

const { actions, reducer } = adminSlice

export const {
    updateSearchString,
    updateSelectedUsersList,
    updateAccessConfigFilter,
    setModalVisibility,
    setDefaultModalSettings,
    updateModalSettings,
    toggleSortOrder,
    selectAllUsers,
    toggleTokensVisible
} = actions

export default reducer
